import type { BreadcrumbItemData } from '@/components/Breadcrumb/breadcrumb';
import { WIKI_ARTICLE_TYPE } from '@/features/wiki/types';

const WIKI_ARTICLE_BREADCRUMB_SECTIONS: Record<string, { label: string; href: string }> = {
  [WIKI_ARTICLE_TYPE.faq]: { label: 'F.A.Q.', href: '/wiki/faq' },
  [WIKI_ARTICLE_TYPE.harryPotterWiki]: {
    label: 'Гарри Поттер Вики',
    href: '/wiki/harry-potter-wiki',
  },
};

export function buildWorkBreadcrumbs(
  title: string,
  workPathPrefix: '/fanfics' | '/originals',
): BreadcrumbItemData[] {
  const sectionLabel = workPathPrefix === '/originals' ? 'Ориджиналы' : 'Фанфики';

  return [
    { label: 'Главная', href: '/' },
    { label: sectionLabel, href: workPathPrefix },
    { label: title },
  ];
}

export function buildArticleBreadcrumbs(
  title: string,
  articleType?: string | null,
): BreadcrumbItemData[] {
  const wikiSection = articleType ? WIKI_ARTICLE_BREADCRUMB_SECTIONS[articleType] : undefined;

  if (wikiSection) {
    return [{ label: 'Вики', href: '/wiki' }, wikiSection, { label: title }];
  }

  return [{ label: 'Главная', href: '/' }, { label: 'Медиа', href: '/media' }, { label: title }];
}

export function buildMediaAuthorsCatalogBreadcrumbs(): BreadcrumbItemData[] {
  return [
    { label: 'Главная', href: '/' },
    { label: 'Медиа', href: '/media' },
    { label: 'Авторы' },
  ];
}

export function buildMediaAuthorBreadcrumbs(authorName: string): BreadcrumbItemData[] {
  return [
    { label: 'Главная', href: '/' },
    { label: 'Медиа', href: '/media' },
    { label: 'Авторы', href: '/media/authors' },
    { label: authorName },
  ];
}

export function buildBreadcrumbSchema(
  items: BreadcrumbItemData[],
  siteUrl: string,
  currentPageUrl: string,
) {
  const baseUrl = siteUrl.replace(/\/$/, '');

  const resolveUrl = (href: string) =>
    href.startsWith('http') ? href : `${baseUrl}${href.startsWith('/') ? href : `/${href}`}`;

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => {
      const isLast = index === items.length - 1;
      const itemUrl = item.href
        ? resolveUrl(item.href)
        : isLast
          ? resolveUrl(currentPageUrl)
          : undefined;

      const listItem: Record<string, unknown> = {
        '@type': 'ListItem',
        position: index + 1,
        name: item.label,
      };

      if (itemUrl) {
        listItem.item = itemUrl;
      }

      return listItem;
    }),
  };
}
